import { registerFr } from '../i18n/index.js';

registerFr({
  'one tool registry, two transports': 'un registre d’outils, deux transports',
  'every caller is a principal with scopes': 'chaque appelant est un principal avec des portées',
  'the scout never touches the database': 'le scout ne touche jamais la base de données',
  'Event feed →': 'Flux d’événements →',
  'New principal': 'Nouveau principal',
  'Checking…': 'Vérification…',
  'checking…': 'vérification…',
  'Ready': 'Prêt',
  'Attend': 'À surveiller',
  'LiteLLM': 'LiteLLM',
  'model unset': 'modèle non défini',
  'unreachable': 'injoignable',
  'Harness': 'Harness',
  'found': 'trouvé',
  'not found': 'introuvable',
  'runtime': 'exécution',
  'cap {n}': 'plafond {n}',
  'night': 'nuit',
  'embedding': 'embedding',
  'reranker': 'reranker',
  'scout': 'scout',
  'seen {time}': 'vu {time}',
  'last seen {time}': 'vu pour la dernière fois {time}',
  'no worker\u2016scout': 'aucun worker',
  'mail': 'courriel',
  'inbound': 'entrant',
  'Surfe': 'Surfe',
  'search': 'recherche',
  'email': 'e-mail',
  'Hermes': 'Hermes',
  'not installed': 'non installé',
  'installed': 'installé',
  'config has crm': 'config avec crm',
  'config lacks crm': 'config sans crm',
  'last call': 'dernier appel',
  'Database': 'Base de données',
  'Re-check': 'Revérifier',
  'Runs · 24h': 'Exécutions · 24 h',
  'no run in the last 24 hours': 'aucune exécution dans les dernières 24 heures',
  '{done} done · {failed} failed · {active} active': '{done} terminées · {failed} échouées · {active} actives',
  'the ledger did not answer': 'le registre n’a pas répondu',
  'counting…': 'décompte…',
  'Filed': 'Déposées',
  'no proposal has come from an agent yet': 'aucune proposition d’agent pour l’instant',
  '{unheld} unheld · {held} held · {refused} refused': '{unheld} en attente · {held} retenues · {refused} refusées',
  'proposals by agents, all time': 'propositions des agents, depuis le début',
  'Pushed back': 'Renvoyées',
  '{n} on {principal} · {reason}': '{n} pour {principal} · {reason}',
  'no agent proposal refused in 7 days': 'aucune proposition d’agent refusée en 7 jours',
  'refused proposals by agents, 7 days': 'propositions d’agents refusées, 7 jours',
  'Hermes · 24h': 'Hermes · 24 h',
  'calls': 'appels',
  'Hermes is not installed on this host': 'Hermes n’est pas installé sur cet hôte',
  'no call from hermes in 24 hours': 'aucun appel de hermes en 24 heures',
  '{read} read · {propose} propose · 0 commit · 0 send': '{read} lecture · {propose} proposition · 0 validation · 0 envoi',
  'ledger calls by principal hermes': 'appels au registre du principal hermes',
  'Send scope': 'Portée envoi',
  'off': 'désactivée',
  'for every agent': 'pour chaque agent',
  'only the operator sends': 'seul l’opérateur envoie',
  'Runs': 'Exécutions',
  'one run = one sentence and its seal': 'une exécution = une phrase et son sceau',
  'Could not load the runs: {error}': 'Impossible de charger les exécutions : {error}',
  'The runner has not reported yet. A run is one DeepSeek Harness process per skill — research, mail triage, transcript, persona — with its own principal, its own token and its own ledger rows.':
    'L’exécuteur n’a encore rien rapporté. Une exécution est un processus DeepSeek Harness par compétence — recherche, tri du courrier, transcription, persona — avec son propre principal, son propre jeton et ses propres lignes de registre.',
  'No run yet. "Research" on a person or an organisation starts one; the nightly schedule starts the rest.':
    'Aucune exécution pour l’instant. « Rechercher » sur une personne ou une organisation en lance une ; la planification nocturne lance les autres.',
  'failed\u2016run': 'échouée',
  'aborted': 'interrompue',
  'running': 'en cours',
  'schedule': 'planification',
  'event': 'événement',
  'agent': 'agent',
  'filed': 'déposées',
  'turns': 'tours',
  'tokens': 'tokens',
  'Abort': 'Interrompre',
  'Open this run’s desk': 'Ouvrir le poste de cette passe',
  '{ref} aborted.': '{ref} interrompue.',
  'Event feed': 'Flux d’événements',
  'append-only · what the consumers and Hermes read': 'en ajout seul · ce que lisent les consommateurs et Hermes',
  'Could not load the events: {error}': 'Impossible de charger les événements : {error}',
  'No event yet. The first interaction, commitment, proposal or signal writes one.': 'Aucun événement pour l’instant. La première interaction, le premier engagement, la première proposition ou le premier signal en écrit un.',
  'Tool registry': 'Registre d’outils',
  'capabilities by scope · which principals hold them': 'capacités par scope · quels principals les détiennent',
  'tools': 'outils',
  'Could not load the registry: {error}': 'Impossible de charger le registre : {error}',
  'no principal holds it': 'aucun principal ne la détient',
  'not a capability': 'pas une capacité',
  'operator only': 'opérateur seulement',
  'Defined once (P9); served as REST, as MCP over HTTP for Hermes and for every run’s harness, and over stdio for Claude Code. Scope is checked in the tool layer, never in a prompt. Every call writes one ledger row, refusals included.':
    'Défini une fois (P9) ; servi en REST, en MCP sur HTTP pour Hermes et pour le harness de chaque passe, et sur stdio pour Claude Code. La portée est vérifiée dans la couche outil, jamais dans un prompt. Chaque appel écrit une ligne de registre, refus compris.',
}, 'AgentsPage');
